"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PrimitiveTypeEnum;

(function (PrimitiveTypeEnum) {
  PrimitiveTypeEnum[PrimitiveTypeEnum["Number"] = 937120] = "Number";
  PrimitiveTypeEnum[PrimitiveTypeEnum["Boolean"] = 937121] = "Boolean";
  PrimitiveTypeEnum[PrimitiveTypeEnum["String"] = 937123] = "String";
  PrimitiveTypeEnum[PrimitiveTypeEnum["Null"] = 937124] = "Null";
  PrimitiveTypeEnum[PrimitiveTypeEnum["Undefined"] = 937125] = "Undefined";
})(PrimitiveTypeEnum = exports.PrimitiveTypeEnum || (exports.PrimitiveTypeEnum = {}));

function typeForTypeName(name) {
  switch (name) {
    case 'Number':
      return PrimitiveTypeEnum.Number;

    case 'Boolean':
      return PrimitiveTypeEnum.Boolean;

    case 'String':
      return PrimitiveTypeEnum.String;

    case 'Null':
      return PrimitiveTypeEnum.Null;

    case 'Undefined':
      return PrimitiveTypeEnum.Undefined;

    default:
      return undefined;
  }
}

exports.typeForTypeName = typeForTypeName;
/**
 * Return if value is a primitive type or an instance of a primitive class
 *
 * @param value
 * @return {boolean}
 */

function isPrimitive(value) {
  if (typeof value !== 'object') {
    return true;
  } else {
    return typeForTypeName(value.constructor.name) !== undefined;
  }
}

exports.isPrimitive = isPrimitive;
/**
 * Return if value is neither primitive type nor an instance of a primitive class
 *
 * @param value
 * @return {boolean}
 */

function isNotPrimitive(value) {
  return !isPrimitive(value);
}

exports.isNotPrimitive = isNotPrimitive;

function typeNameForEnum(value) {
  if (!isPrimitiveTypeEnum(value)) {
    throw new TypeError('Given value is not a PrimitiveTypeEnum');
  }

  switch (value) {
    case PrimitiveTypeEnum.Number:
      return 'Number';

    case PrimitiveTypeEnum.Boolean:
      return 'Boolean';

    case PrimitiveTypeEnum.String:
      return 'String';

    case PrimitiveTypeEnum.Null:
      return 'Null';

    case PrimitiveTypeEnum.Undefined:
      return 'Undefined';
  }
}

exports.typeNameForEnum = typeNameForEnum;

function isPrimitiveTypeEnum(value) {
  return value in PrimitiveTypeEnum;
}

exports.isPrimitiveTypeEnum = isPrimitiveTypeEnum;